<form class="routed-component-layout" (ngSubmit)="onSubmit()" [formGroup]="form" autocomplete="off" *ngIf="form">

  <div class="routed-component-body">
    <div class="routed-component-title-block">

      <h2>{{ "REGISTRATION.ADMIN.TITLE" | translate }}</h2>
      <h5>{{ "REGISTRATION.ADMIN.DEFINITION"  | translate }}</h5>
    </div>

    <h4 *ngIf="!applicantIsLegalRep"><strong>{{ 'REGISTRATION.ADMIN.ARE_YOU_ADMIN' | translate }}</strong></h4>
    <h4 *ngIf="applicantIsLegalRep"><strong>{{ 'REGISTRATION.ADMIN.ARE_YOU_ADMIN_ALSO' | translate }}</strong></h4>

    <soldo-field-layout
      [control]="form.controls.adminChoice"
      fieldName="adminChoice"
      cypressSelector="Admin_RadioButton_AdminSelection">

      <fieldset input class="field-group-layout">
        <div data-cy="Admin_RadioButton_AdminSelection_Applicant">
          <input id="choiceApplicant" type="radio" name="adminChoice" [formControl]="form.controls.adminChoice" [value]="ADMIN_CHOICE.APPLICANT" >
          <label for="choiceApplicant">{{ "REGISTRATION.ADMIN.ADMIN_CHOICE.APPLICANT" | translate: {firstName: applicantContact.firstName, lastName: applicantContact.lastName } }}</label>
        </div>
        <div data-cy="Admin_RadioButton_AdminSelection_LegalRepresentative" *ngIf="!applicantIsLegalRep">
          <input id="choiceLegalRep" type="radio" name="adminChoice" [formControl]="form.controls.adminChoice" [value]="ADMIN_CHOICE.LEGAL_REPRESENTATIVE" >
          <label for="choiceLegalRep">{{ "REGISTRATION.ADMIN.ADMIN_CHOICE.LEGAL_REPRESENTATIVE" | translate: {firstName: legalRepContact.firstName, lastName: legalRepContact.lastName } }}</label>
        </div>
        <div data-cy="Admin_RadioButton_AdminSelection_Other">
          <input id="choiceOther" type="radio" name="adminChoice" [formControl]="form.controls.adminChoice" [value]="ADMIN_CHOICE.OTHER" >
          <label for="choiceOther">{{ "REGISTRATION.ADMIN.ADMIN_CHOICE.OTHER" | translate }}</label>
        </div>
      </fieldset>

      <ng-container errorMessage>
        <soldo-field-error error errorName="required">{{ 'REQUIRED' | translate }}</soldo-field-error>
      </ng-container>
    </soldo-field-layout>

    <h5>{{ 'REGISTRATION.ADMIN.ADD_MORE_LATER' | translate }}</h5>

    <div class="callout informative">
      <div class="callout-content">
        <p>{{ "REGISTRATION.ADMIN.CALLOUT_PARAGRAPH" | translate: {regulatoryInstitution: regulatoryInstitution} }}</p>
        <a [href]="registrationProcessURL" tabindex="0" target="_blank">{{ "REGISTRATION.ADMIN.CALLOUT_LINK" | translate }}</a>
      </div>
    </div>

    <ng-container *ngIf="form.value.adminChoice !== ADMIN_CHOICE.NO_CHOICE">
      <h4>{{ "REGISTRATION.ADMIN.FORM_TITLE" | translate }}</h4>
      <person-form
        [personFormGroup]="form.controls.admin"
        [readonly]="readonly"
        [applyUniquenessChecks]="true"
        [checkInArray]="contactsDTO"
        [emailIsReadonly]="form.value.adminChoice === ADMIN_CHOICE.APPLICANT"
        [translatedCountries]="translatedCountries"></person-form>
    </ng-container>
  </div>
  <div class="navigation-controls-layout">
    <div class="routed-component-cta">
      <button type="button" (click)="goToPrevious()" data-cy="Button_StepBackButton">
        {{ 'PREVIOUS' | translate}}
      </button>

      <button type="submit" class="primary" [disabled]="loading" [ngClass]="{ 'loading': loading }" data-cy="Button_StepSubmitButton">
        {{ 'NEXT' | translate}}
      </button>
    </div>

    <save-and-continue-later stepName="Account Admin"></save-and-continue-later>
  </div>
</form>
